module.exports = __webpack_public_path__ + "img/ic_barrier_blue.434c099d.png";